package com.patronat.top.core.di

import com.patronat.top.core.auth.AuthTokenStorage
import com.patronat.top.core.auth.TokenStorage
import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.dispatchers.StandardDispatcherProvider
import com.patronat.top.core.network.HttpClientFactory
import com.patronat.top.core.presentation.AlertController
import org.koin.dsl.module

val clientCoreModule = module {

    includes(platformModule)

    single<DispatcherProvider> { StandardDispatcherProvider() }

    single<TokenStorage> {
        AuthTokenStorage(settings = get(), dispatchers = get())
    }

    single {
        HttpClientFactory.create(
            tokenStorage = get(),
            baseUrl = getBaseUrl(),
            enableLogging = true
        )
    }

    single { AlertController() }
}

private fun getBaseUrl(): String {
    return ApiConfiguration.BASE_URL
}
